// The client ID is obtained from the {{ Google Cloud Console }}
// at {{ https://cloud.google.com/console }}.
// If you run this code from a server other than http://localhost,
// you need to register your own client ID.
// The client ID is obtained from the {{ Google Cloud Console }}
// at {{ https://cloud.google.com/console }}.
// If you run this code from a server other than http://localhost,
// you need to register your own client ID.
window.sendibleGoogleAuth1stRun = true;

window.sendibleGoogleAuth = {
  api_key: window.appConfig.googleKeys.api_key,
  OAUTH2_CLIENT_ID: window.appConfig.googleKeys.oauth,
  OAUTH2_SCOPES: 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/yt-analytics.readonly https://www.googleapis.com/auth/youtube.readonly',
  token: null,
  authorized: false,
  pickerReady: false,
  clientReady: false,

  loadGapi() {
    this.addScript('https://apis.google.com/js/api.js', () => {
      gapi.load('picker', () => {
        this.pickerReady = true;
      });
      gapi.load('client', () => {
        this.clientReady = true;
      });
    });
    
    this.addScript('https://accounts.google.com/gsi/client');
  },

  addScript(url, callback = () => {}){
    const s = document.createElement('script');
    s.id = 'script-loader-google-client';
    s.type = 'text/javascript';
    s.defer = true;
    s.async = true;
    s.onload = callback;
    s.src = url;
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  },

  authoriseCloudServiceGapi(service) {

    if (!service) {
      return;
    }
    const { user_id } = loginContext.getDefaultLoginDetails();
    const accessToken = storageUtils.getCookieOrLocalStorageItem(`s_accessToken_${user_id}`);
    let url = `${window.appConfig.api_url}/api/v3/google/client_side_oauth`;
    url += `?service=${service}&access_token=${accessToken}`;
    const width = 800;
    const height = 500;
    const left = (screen.width / 2) + window.screenX - (width / 2);
    const top = (screen.height / 2) - (height / 2);

    window.open(url, 'google-cloud', `height=${height},width=${width},modal=yes,scrollbars=yes,alwaysRaised=yes,top=${top},left=${left}`);
  },

  setAccessToken(accessToken) {
    if (accessToken) {
      this.token = accessToken;
    }
  },

  revertAccessToken() {
    this.token = null;
  },

  authoriseGapi(callback = () => {}) {
    const client = google.accounts.oauth2.initTokenClient({
      client_id: window.sendibleGoogleAuth.OAUTH2_CLIENT_ID,
      scope: window.sendibleGoogleAuth.OAUTH2_SCOPES,
      callback: (token) => {
        if (token) {
          this.token = token;
        }

        callback();
      },
      error_callback: (messageObject) => {
        if(messageObject.message !== 'Popup window closed'){
          Utils.notify(`${window.lookup('It appears that you are blocking popups')}. ${window.lookup('To use this feature you must enable popups')}.`, 'error', false, true);
        }
      }
    });

    client.requestAccessToken();
  },

  getGoogleAnalyticsAccounts() {
    $.ajax({
      url: `https://www.googleapis.com/analytics/v3/management/accounts?access_token=${sendibleGoogleAuth.token.access_token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::accounts-retreived', data);
      }, this),
    });
  },

  getGoogleAnalyticsProperties(googleAccountsId) {
    return $.ajax({
      url: `https://www.googleapis.com/analytics/v3/management/accounts/${googleAccountsId}/webproperties?access_token=${sendibleGoogleAuth.token.access_token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::properties-retreived', data);

        return data;
      }, this),
    });
  },

  getGoogleAnalyticsWebProperties(googleAccountsIdArg, googlePropertiesIdArg) {
    const googleAccountsId = (typeof googleAccountsIdArg === 'undefined') ? '~all' : googleAccountsIdArg;
    const googlePropertiesId = (typeof googlePropertiesIdArg === 'undefined') ? '~all' : googlePropertiesIdArg;

    $.ajax({
      url: `https://www.googleapis.com/analytics/v3/management/accounts/${googleAccountsId}/webproperties/?access_token=${sendibleGoogleAuth.token.access_token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::web-properties-retreived', data);
      }, this),
      error: _.bind((data) => {
        Backbone.trigger('gapi::web-properties-retreived-error', data);
      }, this),
    });
  },

  getGoogleAnalyticsProfiles(googleAccountsIdArg, googlePropertiesIdArg) {
    const googleAccountsId = (typeof googleAccountsIdArg === 'undefined') ? '~all' : googleAccountsIdArg;
    const googlePropertiesId = (typeof googlePropertiesIdArg === 'undefined') ? '~all' : googlePropertiesIdArg;

    return $.ajax({
      url: `https://www.googleapis.com/analytics/v3/management/accounts/${googleAccountsId}/webproperties/${googlePropertiesId}/profiles?access_token=${sendibleGoogleAuth.token.access_token}`,
      success(data) {
        Backbone.trigger('gapi::profiles-retreived', data);
        return data;
      },
      error(data) {
        Backbone.trigger('gapi::profiles-retreived-error', data);
        return data;
      },
    });
  },

  getGoogleAnalyticsAccountSummaries() {
    return $.ajax({
      url: 'https://analyticsadmin.googleapis.com/v1beta/accountSummaries',
      headers: {
        'Authorization': `Bearer ${sendibleGoogleAuth.token.access_token}`
      },
      success(data) {
        Backbone.trigger('gapi::account-summaries-retreived', data);
        return data;
      },
      error(data) {
        Backbone.trigger('gapi::account-summaries-retreived-error', data);
        return data;
      },
    });
  },

  getSelfLinkData(link) {
    return $.ajax({
      url: `${link}?access_token=${sendibleGoogleAuth.token.access_token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::self-link-retreived', data);
      }, this),
      error: _.bind((data) => {
        Backbone.trigger('gapi::self-link-retreived-error', data);
      }, this),
    });
  },

  getGoogleAnalyticsData(googleAccountsProfileID) {
    $.ajax({
      url: `https://www.googleapis.com/analytics/v3/data/ga?ids=ga:${googleAccountsProfileID}&start-date=2016-08-01&end-date=2016-08-09&&metrics=ga:sessions&access_token=${sendibleGoogleAuth.token.access_token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::data-retreived', data);
      }, this),
      error: _.bind((data) => {
        Backbone.trigger('gapi::data-retreived-error', data);
      }, this),
    });
  },

  testAccessToken(token) {
    $.ajax({
      url: `https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${token}`,
      success: _.bind((data) => {
        Backbone.trigger('gapi::token-valid', data);
      }, this),
      error: _.bind((data) => {
        Backbone.trigger('gapi::token-invalid', data);
      }, this),
    });
  },

  refreshTokenAndRefreshToken() {
    const url = `${api_url}/dashboards?get_google_analytics=1`;
    const width = 800;
    const height = 500;
    const left = (screen.width / 2) + window.screenX - (width / 2);
    const top = (screen.height / 2) - (height / 2);

    window.open(url, 'google-analytics', `height=${height},width=${width},modal=yes,scrollbars=yes,alwaysRaised=yes,top=${top},left=${left}`);
  },
}
